import React from 'react';
import { OutlinedInput, OutlinedInputProps } from '@mui/material';
import { COLORS_WHITE } from '../../../App.constants';

export const CustomOutlinedInput: React.FC<OutlinedInputProps> = (props) => {
  return (
    <OutlinedInput
      {...props}
      style={{
        borderRadius: '0',
        backgroundColor: COLORS_WHITE,
      }}
      inputProps={{
        style: {
          padding: '10px',
          // textAlign: 'right',
        },
      }}
    />
  );
};

CustomOutlinedInput.displayName = 'CustomOutlinedInput';
